import { graphql } from "../gql";

export const getAuditorUserQueryDoc = graphql(`
  query getAuditorUser(
    $id: UUID!
    $insurerUsersOrderBy: [InsurerUsersOrderBy!]
  ) {
    auditorUser(id: $id) {
      id
      firstName
      lastName
      title
      email
      userType
      readOnly
      internalOnly
      claimIntakeEnabled
      insurerUsers(orderBy: $insurerUsersOrderBy) {
        nodes {
          id
          auditorUserId
          insurerId
          insurer {
            ...InsurerFragment
          }
        }
      }
      providerUserFacilities {
        nodes {
          id
          provider {
            id
            name
          }
        }
      }
    }
  }
`);
